/**
 * RN-002 — todos os cálculos de dia usam a hora de Luanda (UTC+1),
 * independentemente do fuso do dispositivo.
 *
 * Um estudante em Lisboa e outro em Luanda têm de ver a mesma sequência para o
 * mesmo esforço. Se o dia civil fosse o do dispositivo, mudar de fuso durante
 * uma viagem partia ou oferecia dias, e ninguém entenderia porquê.
 *
 * Angola não tem hora de Verão, portanto um deslocamento fixo é correcto e não
 * é uma simplificação. Se algum dia houver um fuso com mudança sazonal, isto
 * passa a precisar de `Intl.DateTimeFormat` com `timeZone` — e não de mais um
 * número somado aqui.
 */

const DESLOCAMENTO_MS = 60 * 60 * 1000; // UTC+1
export const DIA_MS = 24 * 60 * 60 * 1000;

/** Dia civil em Luanda, no formato `AAAA-MM-DD`. */
export function diaEmLuanda(instante: number = Date.now()): string {
  return new Date(instante + DESLOCAMENTO_MS).toISOString().slice(0, 10);
}

/** Quantos dias civis separam dois dias, em Luanda. */
export function diasEntre(de: string, ate: string): number {
  return Math.round((Date.parse(`${ate}T00:00:00Z`) - Date.parse(`${de}T00:00:00Z`)) / DIA_MS);
}

/**
 * Sequência diária a partir dos dias em que houve actividade (RF-041).
 *
 * Conta para trás a partir de hoje. Se não houve actividade hoje mas houve
 * ontem, a sequência ainda está viva — só quebra depois de passar um dia
 * inteiro sem nada. Quebrar à meia-noite de um dia em que ainda se pode
 * estudar seria punir quem estuda à noite.
 */
export function sequencia(dias: readonly string[], hoje: string = diaEmLuanda()): number {
  if (dias.length === 0) return 0;
  const unicos = [...new Set(dias)].sort().reverse();

  const distanciaAoTopo = diasEntre(unicos[0]!, hoje);
  if (distanciaAoTopo > 1) return 0;

  let conta = 1;
  for (let i = 1; i < unicos.length; i++) {
    if (diasEntre(unicos[i]!, unicos[i - 1]!) !== 1) break;
    conta += 1;
  }
  return conta;
}
